import { __assign, __rest } from "tslib";
import React from 'react';
import { Svg } from '@marvelapp/ui';
export default function Minus(_a) {
    var props = __rest(_a, []);
    return (React.createElement(Svg, __assign({ display: "block", height: "14", viewBox: "0 0 14 14", width: "14" }, props),
        React.createElement("rect", { fillRule: "evenodd", height: "2", rx: "1", width: "12", x: "1", y: "6" })));
}
